import React from "react";
import { getQueryStringParams } from "sharedUtils/navUtils"
import { Helmet } from "react-helmet";

class MerchantPage extends React.Component {

    async componentDidMount() {
        this.props.setShowTopNav(false);
        const path = window.location.pathname;
        const index = path.lastIndexOf("/") + 1;
        const merchantId = path.slice(index);

        var objUrlParams = new URLSearchParams(window.location.search);
        const creatorUserId = objUrlParams.get("userId");

        const redirectUrl = getQueryStringParams(window.location.search).redirecturl;
        const currentDeal = getQueryStringParams(window.location.search).currentDeal;

        const trackingShareLink = window.location.href;

        const params = getQueryStringParams(window.location.search);
        const referrer = params.referrer ?? null;

        const utmId = params.utm_id ?? null;
        const utmSource = params.utm_source ?? null;
        const utmMedium = params.utm_medium ?? null;
        const utmName = params.utm_name ?? null;
        const utmContent = params.utm_content ?? null;
        const utmTerm = params.utm_term ?? null;

        let clickerUserId = "";
        if (this.props?.loggedInUser?.id != null && this.props?.loggedInUser?.id != undefined) {
            clickerUserId = this.props.loggedInUser.id;
        }
        let url = merchantId == null || creatorUserId == null ? "" : `/api/Merchant/RedirectToMerchantWithMerchantIdAndUserId?merchantId=${merchantId}&creatorUserId=${creatorUserId}&referrer=${document.referrer}&clickerUserId=${clickerUserId}`;
        if (!!(redirectUrl)) {
            url = url + "&redirectUrl=" + encodeURIComponent(redirectUrl);
        }
        if (!!(currentDeal)) {
            url = url + "&currentDeal=" + currentDeal;
        }

        url += `&shareLink=${encodeURIComponent(window.location.href)}`

        const isValid = (v) => typeof v === 'string' && v.length > 0;


        if (isValid(utmId)) url += `&utmId=${encodeURIComponent(utmId)}`;
        if (isValid(utmSource)) url += `&utmSource=${encodeURIComponent(utmSource)}`;
        if (isValid(utmMedium)) url += `&utmMedium=${encodeURIComponent(utmMedium)}`;
        if (isValid(utmName)) url += `&utmName=${encodeURIComponent(utmName)}`;
        if (isValid(utmContent)) url += `&utmContent=${encodeURIComponent(utmContent)}`;
        if (isValid(utmTerm)) url += `&utmTerm=${encodeURIComponent(utmTerm)}`;

        if (url !== "") {
            this.merchantPageRedirectGoogleAnalytics4Tracking(url);
            window.location.replace(url);
        }

        this.props.setShowTopNav(false);
    }

    merchantPageRedirectGoogleAnalytics4Tracking = (url) => {
        window.gtag('event', 'MerchantPageRedirect', {
            send_to: 'G-9F2DZRE5FG',
            event_category: 'Redirect',
            event_label: `Merchant Page Redirect`,
            value: url
        });
    }

    render() {
        return (
            <>
                <Helmet>
                    <title>Rockporch - Merchant Redirect</title>
                </Helmet>
            </>
        )
    }
}

export default MerchantPage;